import { Filter } from '../types/podlet';
import { Vertical, Subvertical } from '../types/ast';

export function verticalSpesificPreProccessing(
    filter: Filter,
    vertical: Vertical,
    subvertical?: Subvertical,
) {
    if (vertical === 'travel') {
        const { destinasjon, til } = filter;

        if (destinasjon) {
            if (Array.isArray(destinasjon)) {
                console.warn(
                    `Destination data as array is not supported ${vertical} - ${subvertical}`,
                );
                return filter;
            }
            if (typeof destinasjon === 'object') {
                const { by, land } = destinasjon;
                if (by) {
                    filter['location-city'] = [by];
                }
                if (land) {
                    filter['location-country'] = [land];
                }
                return filter;
            }
            if (subvertical === 'flight') {
                // copy the flight "destinasjon" value into the location-* format
                if (typeof destinasjon === 'string') {
                    const locations = destinasjon.split(';');
                    if (locations.length > 0) {
                        const city = locations[0];
                        if (city) {
                            filter['location-city'] = [city];
                        }
                    }
                    if (locations.length > 1) {
                        const country = locations[1];
                        if (country) {
                            filter['location-country'] = [country];
                        }
                    }
                }
            }

            if (subvertical === 'holiday_rental') {
                // split the fhh "destinasjon" value into the location-* format
                if (typeof destinasjon === 'string') {
                    const locations = destinasjon.split(', ');
                    if (locations.length > 0) {
                        filter['location-country'] = [
                            locations[locations.length - 1],
                        ];
                    }
                    if (locations.length > 1) {
                        filter['location-city'] = [
                            locations[locations.length - 2],
                        ];
                    }
                }
            }

            if (subvertical === 'lastminute') {
                // split the lms "destinasjon" value into the location-* format
                // example: Europa;Storbritannia;England;London
                if (typeof destinasjon === 'string') {
                    const locations = destinasjon.split(';');
                    if (locations.length === 1) {
                        filter['location-country'] = [locations[0]];
                    }
                    if (locations.length > 1) {
                        filter['location-country'] = [locations[1]];
                    }
                    if (locations.length > 3) {
                        filter['location-city'] = [locations[3]];
                    } else if (locations.length > 2) {
                        filter['location-city'] = [locations[2]];
                    }
                }
            }
        }

        if (subvertical === 'hotel') {
            // copy the accommodation "land" value into the location-* format
            if (filter.land && Array.isArray(filter.land)) {
                filter['location-country'] = filter.land;
            }

            // copy the accommodation "til" value into the location-* format
            if (filter.til && Array.isArray(filter.til)) {
                filter['location-city'] = filter.til;
            }
        }
        if (subvertical === 'prepackage') {
            // copy the prepackage "til" into the location-* format
            if (til && Array.isArray(til) && til.length > 0) {
                const locations = til[0].split(';');
                if (locations.length > 1) {
                    const country = locations[1];
                    if (country) {
                        filter['location-country'] = [country];
                    }
                }
                if (locations.length > 3) {
                    const city = locations[3];
                    if (city) {
                        filter['location-city'] = [city];
                    }
                } else if (locations.length > 2) {
                    const city = locations[2];
                    if (city) {
                        filter['location-city'] = [city];
                    }
                }
            }
        }
    }
    return filter;
}
